import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { Field, reduxForm, Form, submit, change } from 'redux-form';
import Button from 'material-ui/Button';
import { Card, CardContent } from 'material-ui';
import { MenuItem } from 'material-ui/Menu';

import { connect } from 'react-redux';

import IconButton from 'material-ui/IconButton';
import Close from 'material-ui-icons/Cancel';

import addEditCustomer from '../actions/addEditCustomer';
import addEditLocation from '../actions/addEditLocation';
import searchAllPages from '../actions/searchAllPages';
import getCustomers from '../actions/getCustomers';

import ReactSelect from '../helpers/ReactSelect';

import renderTextField from '../helpers/RenderTextFiledWithDiv';
import validationHelper from '../helpers/ValidationHelper';
import renderSelectField from '../helpers/RenderSelectField';

const styles = theme => ({
  card: {
    display: 'flex',
    boxShadow: 'none',
  },
  content: {
    flex: '1 0 auto',
  },
  paperStyle: {
    width: '92%',
    height: '70%',
    display: 'inline-block',
    margin: 20,
    marginTop: '5vh'
  },
  marginStyle: {
    margin: 8
  },
  textField: {
    width: 200,
  },
  buttonStyle: {
    marginTop: 10,
    marginBottom: 15,
    textAlign: 'center',
  },
  button: {
    backgroundColor: '#002053',
  },
  formControl: {
    margin: theme.spacing.unit - 5,
    justifyContent: 'center'
  },
  addressTypeDiv: {
    display: 'flex',
    justifyContent: 'center'
  },
  closeIcon: {
    margin: '1%',
    position: 'absolute',
    right: 0,
  }
});

const addressList = { 'Physical Address': { addressType: '*Enter Physical Address' }, 'Billing Address': { addressType: '*Enter Billing Address' } };
let selectedAddress = {};

const getRequiredFields = (country) => {
  const countriesWithStates = ['USA', 'CA', 'MX'];
  const defaultRequiredFields = ['addressType', 'country', 'addressLine1', 'city', 'state', 'county', 'postalCode'];
  if (!country) return defaultRequiredFields;

  let requiredFields = [...defaultRequiredFields];

  // remove county from required fields if selected country is CA or MX
  // if (country === 'CA' || country === 'MX') {
  //   requiredFields = defaultRequiredFields.filter(f => f !== 'county');
  // }

  // remove the state, county, and postal code from required fields if the selected country does not have states
  if (countriesWithStates.indexOf(country) === -1) {
    requiredFields = defaultRequiredFields.filter(f => !['state', /* 'county', */ 'postalCode'].includes(f));
  }

  return requiredFields;
};

const validate = (values, props) => {
  const requiredFields = getRequiredFields(values.country);
  const errors = validationHelper.validateRequired(requiredFields, values);

  const lengthValidation = [
    { field: 'addressLine1', label: 'Address Line 1', value: values.addressLine1, min: 1, max: 50 },
    { field: 'addressLine2', label: 'Address Line 2', value: values.addressLine2, min: 1, max: 50 },
    { field: 'city', label: 'City', value: values.city, min: 1, max: 50 },
    { field: 'postalCode', label: 'Postal Code', value: values.postalCode, min: 5, max: 20 },
    { field: 'county', label: 'County', value: values.county, min: 1, max: 50 },
  ];
  validationHelper.validateLength(errors, lengthValidation);

  if (selectedAddress[values.addressType] !== undefined
      && selectedAddress[values.addressType].country !== ''
      && selectedAddress[values.addressType].country !== undefined
      && props.data.propsValue === '') {
    errors.addressType = `${values.addressType} already added`;
  }

  return errors;
};

const renderStates = (country, props) => {
  if (country && props.data && props.data.stateCountry &&
    props.data.stateCountry.data.find(v => v.country === country)) {
    const { states } = props.data.stateCountry.data.find(v => v.country === country);
    return Object.keys(states).sort().map(s => ({ key: s, value: states[s], label: s }));
  }

  return [{ key: 'NA', value: '', label: 'N/A' }];
};

const renderAddressType = (props) => {
  const menuItems = Object.keys(props.addressTypes ? props.addressTypes : addressList).map(key => <MenuItem value={key} key={key}>{key}</MenuItem>);
  return menuItems;
};

const removeEmptyKeys = (obj) => {
  const clone = {};

  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === 'object') {
      Object.assign(clone, { [key]: removeEmptyKeys(obj[key]) });
    } else if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
      Object.assign(clone, { [key]: obj[key] });
    }
  });

  return clone;
};

class AddressForm extends Component {
  constructor(props) {
    super(props);

    const { customerId, autotecId, locationId, initialValues } = props || {};
    const { country, state } = initialValues || {};

    this.state = {
      country: country || '',
      state: state || '',
      customerId: customerId || '',
      autotecId: autotecId || '',
      locationId: locationId || '',
      saved: false,
    };
  }

  componentWillReceiveProps(newProps) {
    if (newProps.addressList.Address === undefined) {
      selectedAddress = newProps.addressList;
    } else if (!newProps.addressList.PhysicalAddress && !newProps.addressList.BillingAddress) {
      selectedAddress = {};
    }
  }

  handleCountryChange = (event) => {
    const country = event ? event.value : undefined;
    if (!country) return;

    // call redux change action so it keeps track of changes for validation and saving purposes
    this.props.dispatch(change('AddressForm', 'country', country));
    this.props.dispatch(change('AddressForm', 'state', ''));
    this.props.dispatch(change('AddressForm', 'county', ''));
    this.props.dispatch(change('AddressForm', 'postalCode', ''));

    // set state so we show the selected country and update labels accordingly
    this.setState({ country, state: '' });
  };

  handleStateChange = (event) => {
    const state = event ? event.value : undefined;
    if (!state) return;

    // need to call redux change action so it keeps track of changes
    this.props.dispatch(change('AddressForm', 'state', state));
    this.setState({ state });
  };

  handleAddressSave = async (event) => {
    const customer = {
      customerId: this.state.customerId
    };

    selectedAddress[event.addressType] = event;
    if (Object.keys(selectedAddress).length !== Object.keys(addressList).length) {
      Object.keys(addressList).map((key) => {
        if (key !== event.addressType) {
          selectedAddress[key] = addressList[key];
        }
      });
    }

    const address = {};

    Object.keys(selectedAddress).map((addressKey) => {
      Object.keys(selectedAddress[addressKey]).map((k) => {
        if (addressKey === event.addressType) {
          if (k !== 'addressType') {
            address[k] = selectedAddress[addressKey][k];
          }
        }
      });
    });

    const location = {
      address: {
        addressLine1: address.addressLine1,
        addressLine2: address.addressLine2,
        city: address.city,
        country: address.country,
        county: address.county,
        postalCode: address.postalCode,
        state: address.state,
      },
      autotecId: this.props.autotecId,
      locationId: this.props.locationId,
      isActive: this.props.isActive
    };

    if (!address.addressLine2) {
      delete location.address.addressLine2;
    }

    customer[(event.addressType === 'Billing Address' ? 'billingAddress' : 'physicalAddress')] = location.address;

    if (this.state.customerId) {
      const addressLists = this.props.addressList;
      if (event.addressType === 'Billing Address') {
        this.props.actions.saveBillingAddress(customer, this.props.data.config, this);
        const billAddress = customer.billingAddress;
        billAddress.addressType = 'Billing Address';
        addressLists['Billing Address'] = billAddress;
        delete addressLists.Address;
      } else {
        this.props.actions.savePhysicalAddress(customer, location, this.props.data.config, this);
        const physAddress = customer.physicalAddress;
        physAddress.addressType = 'Physical Address';
        addressLists['Physical Address'] = physAddress;
        delete addressLists.Address;
      }
      await this.props.handleAddressSave(addressLists);
    } else {
      await this.props.handleAddressSave(selectedAddress);
    }
    await this.props.actions.refreshData(this.props.data.config);
  };

  submitForm = () => {
    this.props.dispatch(submit('AddressForm'));
  };

  render() {
    const { classes, invalid, handleSubmit } = this.props;
    const { country, fetching } = this.state;
    const states = renderStates(country, this.props);
    const addressTypes = renderAddressType(this.props);
    const requiredFields = getRequiredFields(country);

    return (
      <Form key="AddressForm" onSubmit={handleSubmit(this.handleAddressSave)} style={{ padding: '1em' }}>
        <div className={classes.addressTypeDiv}>
          <span />
          <Field
            disabled={!!this.props.data.propsValue}
            name="addressType"
            component={renderSelectField}
            label="*Address Type"
            className={classes.textField}
            divClassName={classes.formControl}
          >
            {addressTypes}
          </Field>
          <IconButton title="close" className={classes.closeIcon} onClick={this.props.handleAddressClose}>
            <Close color="disabled" />
          </IconButton>
        </div>
        <Card className={classes.card}>
          <CardContent className={classes.content}>
            <Field
              name="addressLine1"
              component={renderTextField}
              label="*Address Line 1"
              className={classes.textField}
              divClassName={classes.formControl}
            />
            <Field
              name="addressLine2"
              component={renderTextField}
              label="Address Line 2"
              className={classes.textField}
              divClassName={classes.formControl}
            />
            <Field
              name="city"
              component={renderTextField}
              label="*City"
              className={classes.textField}
              divClassName={classes.formControl}
            />
          <ReactSelect
              name="country"
              label="*Country"
              placeholder="*Country"
              options={this.props.data.stateCountry.data.find(v => v.country === 'ALL')
              .countries.sort().map(c => ({ key: c.code, value: c.code, label: c.name }))}
              onChange={this.handleCountryChange}
              value={this.state.country}
              style={{ width: 200, backgroundColor: 'transparent', cursor: 'pointer' }}
          />
          </CardContent>
          <CardContent>
            {
              requiredFields.includes('state')
                ?
                    <ReactSelect
                      name="state"
                      label="*State/Province"
                      placeholder="*State/Province"
                      options={states}
                      onChange={this.handleStateChange}
                      value={this.state.state}
                      style={{ width: 200, backgroundColor: 'transparent', cursor: 'pointer' }}
                    />
                  : <Field
                      name="state"
                      component={renderTextField}
                      label="State/Province"
                      className={classes.textField}
                      divClassName={classes.formControl}
                  />
            }
            <Field
              name="county"
              component={renderTextField}
              label={requiredFields.includes('county') ? '*County' : 'County'}
              className={classes.textField}
              divClassName={classes.formControl}
            />
            <Field
              name="postalCode"
              component={renderTextField}
              label={requiredFields.includes('postalCode') ? '*Postal Code' : 'Postal Code'}
              className={classes.textField}
              divClassName={classes.formControl}
            />
          </CardContent>
        </Card>
        <div className={classes.buttonStyle}>
          <div color="danger" style={this.state.saved ? { visibility: 'visible', color: 'red', fontWeight: 'bold' } : { visibility: 'hidden' }}>Address saved</div>
          <Button
              variant="raised"
              color="primary"
              type="button"
              onClick={this.submitForm}
              className={classes.button}
              disabled={fetching || invalid}
          >
            Save
          </Button>
        </div>
      </Form>
    );
  }
}

AddressForm.propTypes = {
  classes: PropTypes.shape().isRequired
};

const mapStateToProps = (state, ownProps) => ({
  data: {
    propsValue: ownProps.addressList[ownProps.addressType] ? ownProps.addressList[ownProps.addressType].country : '',
    config: state.config.config,
    addressList: state.addressList,
    stateCountry: state.stateCountry.stateCountry
  },
  initialValues: ownProps.addressType !== 'Address' ? ownProps.addressList[ownProps.addressType] : {}
});

const mapDispatchToProps = dispatch => ({
  actions: {
    refreshData: (config) => {
      dispatch(searchAllPages('person-locations', config));
      dispatch(searchAllPages('locations', config, true));
      dispatch(getCustomers(config));
      dispatch(searchAllPages('persons', config));
    },
    saveBillingAddress: (customer, config, self) => {
      self.setState({
        fetching: true,
        addressList: { Address: { addressType: '*Enter Physical Address' } },
      });

      if (!customer.primaryLocationId && self.props.locationId) {
        customer.primaryLocationId = self.props.locationId;
      }

      const customerToSave = removeEmptyKeys(customer);
      dispatch(addEditCustomer(customerToSave, config)).then(() => {
        self.setState({ fetching: false, saved: true });
      });
    },
    savePhysicalAddress: (customer, location, config, self) => {
      self.setState({
        fetching: true,
        addressList: { Address: { addressType: '*Enter Billing Address' } }
      });

      const locationToSave = removeEmptyKeys(location);
      locationToSave.customerId = self.props.customerId;
      dispatch(addEditLocation(locationToSave, config)).then(async (p) => {
        await self.setState({ fetching: false, saved: true, locationId: p.value.data.locationId });
        await self.props.handleGetLocationId(p.value.data.locationId);
      });
    }
  }
});

const ReduxForm = withStyles(styles, { withTheme: true })(reduxForm({
  form: 'AddressForm',
  validate
})(AddressForm));

const ConnectedAddressForm = connect(mapStateToProps, mapDispatchToProps)(ReduxForm);

export default ConnectedAddressForm;


// WEBPACK FOOTER //
// ./src/containers/AddressForm.js